import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../artzu-ui/src/Button';

// import FontAwesomeIcon from '@fortawesome/react-fontawesome';
// import {
//   faHome,
//   faArrowRight,
//   faArrowLeft
// } from '@fortawesome/pro-regular-svg-icons';

class NewNavButtonGroup extends Component {
  render() {
    const { changePage, page, disabled, passed } = this.props;
    const NextButton = (
      <Button
        padding="0"
        primary
        label="Next"
        size="xl"
        onClick={() => changePage(page + 1, passed)}
      />
    );
    const QuizButton = (
      <Link to={/coursehtml/.test(window.location.href) ? "/examhtml" : "/exam"}>
        <Button
          padding="0" primary label="Start" size="xl" />
      </Link>
    );
    // const QuizButton = () => {
    //   if (page !== 6) {
    //     return (
    //       <Button
    //         primary
    //         label="Next"
    //         size="xl"
    //         onClick={() => changePage(page + 1, passed)}
    //       />
    //     );
    //   } else {
    //     return (
    //       <Link to="/exam">
    //         <Button
    //       </Link>
    //     );
    //   }
    // };

    const DisableQuizButton = (
      <Button
        padding="0" primary disabled label="Start" size="xl" />
    );

    const renderPrevNext = (
      <div className="new-course__body__buttons">
        <Button
          padding="0"
          label="Previous"
          color="#414141"
          size="xl"
          onClick={() => changePage(page - 1, passed)}
        />
        {/* {disabled
          ? QuizButton
          : passed && page === 6 ? DisableQuizButton : NextButton} */}
        {/* {passed && page === 6 ? DisableQuizButton : NextButton} */}

        {page === 6
          ? passed ? DisableQuizButton : QuizButton
          : NextButton}
      </div>
    );

    const renderStartCourse = (
      <div className="new-course__body__startCourse">
        <Button
          padding="0"
          primary
          label="Start Course"
          size="xl"
          fullWidth={true}
          onClick={() => changePage(1, passed)}
        />
      </div>
    );
    return (
      <Fragment>
        {page === 0 ? renderStartCourse : renderPrevNext}
      </Fragment>
    );
  }
}

export default NewNavButtonGroup;

{
  /* <div className="course-section_button-group">
      <button
        padding="0"
        className="course-section_button round"
        onClick={() => changePage(page - 1, passed)}>
        <FontAwesomeIcon icon={faArrowLeft} fixedWidth size="lg" />
      </button>

      <button
        padding="0"
        className="course-section_button round"
        onClick={() => changePage(0, passed)}>
        <FontAwesomeIcon icon={faHome} fixedWidth size="lg" />
        page
      </button>

      <button
        padding="0"
        disabled={disabled}
        className={`course-section_button${
          disabled ? ' disabled' : ''
        } round`}
        onClick={() => changePage(page + 1, passed)}>
        <FontAwesomeIcon icon={faArrowRight} fixedWidth size="lg" />
      </button>
    </div> */
}



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewNavButtonGroup.js